<pdq-tabs-group class="dynamic-reviews-tabs" variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab
      [label]="tab.label"
      [value]="tab.value"
      [active]="tab.value === activeTab"
      [disabled]="tab.disabled"
      [locked]="tab.locked"></pdq-tab>
  }
</pdq-tabs-group>

<div class="dynamic-reviews-content">
  <div class="content">
    @if (formGroup) {
      <form [formGroup]="formGroup">
        @switch (activeTab) {
          @case (DynamicReviewsTab.SETTINGS) {
            <dynamic-reviews-form-settings
              [formGroup]="formGroup"
              [loadedExtension]="loadedExtension"
              [excludeProductsRules]="excludeProductsRules"
              [excludeProductsEntities]="excludeProductsEntities"
              (addExcludedProducts)="onAddExcludedProducts()"
              (removeExcludedProduct)="onRemoveExcludedProduct($event)">
            </dynamic-reviews-form-settings>
          }
          @case (DynamicReviewsTab.APPEARANCE) {
            <dynamic-reviews-form-appearance [formGroup]="formGroup"></dynamic-reviews-form-appearance>
          }
          @case (DynamicReviewsTab.DISPLAY_CONDITIONS) {
            <dynamic-reviews-form-display-conditions
              [formGroup]="formGroup"
              [displayRules]="displayRules"
              [displayRulesEntities]="displayRulesEntities">
            </dynamic-reviews-form-display-conditions>
          }
        }
      </form>
    }
  </div>
</div>
